var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share"},[_c('span',[_vm._v("Share:")]),_c('ul',{staticClass:"social"},_vm._l((_vm.socialList),function(social,i){return _c('li',{key:i},[_c('a',{attrs:{"href":social.link,"target":"_blank","rel":"noreferrer"}},[_c('img',{staticClass:"svg",attrs:{"src":social.src,"alt":"social"}})])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }